/*
  Belilan i18n runtime. Two jobs, no dependencies, no app.

  1. Language switch — the EN / FR buttons in snippets/language-switcher.liquid post
     Shopify's own localization form, so Shopify maps the current page to its
     equivalent in the target language.

  2. Locale-aware internal links — section settings store plain paths such as
     "/collections/all". Liquid prints those verbatim, so on /fr a shopper clicking
     one is dumped back into the English storefront. Nothing in Liquid fixes this
     centrally, and this theme has 35 such links on the homepage alone, so the
     prefix is applied here instead of forking every section.
*/
(function () {
  'use strict';

  /* --- 1. Language switch ------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var pick = event.target.closest && event.target.closest('[data-bl-locale]');
    if (!pick) return;
    event.preventDefault();
    if (pick.getAttribute('aria-current') === 'true') return;

    var form = pick.closest('form');
    if (!form) return;
    var input = form.querySelector('[data-bl-locale-input]');
    if (input) input.value = pick.getAttribute('data-bl-locale');
    form.submit();
  });

  /* --- 2. Locale-aware internal links ------------------------------------ */
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root === '/') return;

  var prefix = root.replace(/\/+$/, ''); // "/fr"

  // Allowlist. Only storefront paths a shopper navigates to. Deliberately excludes
  // /cart/change, /cart/add and every other AJAX endpoint the theme's JS builds.
  var LOCALIZABLE = /^\/(collections|products|pages|blogs|policies|search|account)(\/|$|\?|#)/;

  function localize(anchor) {
    var href = anchor.getAttribute('href');
    if (!href || href.charAt(0) !== '/' || href.charAt(1) === '/') return;
    if (href === prefix || href.indexOf(prefix + '/') === 0) return; // already prefixed
    if (href !== '/' && href !== '/cart' && !LOCALIZABLE.test(href)) return;
    anchor.setAttribute('href', href === '/' ? prefix + '/' : prefix + href);
  }

  function sweep(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName === 'A') localize(node);
    if (!node.querySelectorAll) return;
    var found = node.querySelectorAll('a[href^="/"]');
    for (var i = 0; i < found.length; i++) localize(found[i]);
  }

  function start() {
    sweep(document.body);
    // Quick view, cart drawer, predictive search and infinite scroll all inject
    // markup after load, so keep watching rather than sweeping once.
    if (!window.MutationObserver) return;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) sweep(added[j]);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
